import React from 'react'
import PropTypes from 'prop-types'

export function SearchHighlightedText({
  size = '100%',
  colour = 'currentColor',
  ...props
}) {
  return (
    <div
      style={{
        height: '30px',
        display: 'flex',
        alignItems: 'top',
        padding: '5px 0',
        margin: '0 -10px'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 256 256"
      >
        <g xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
          <path
            fill={colour}
            d="M70.4,140.8c-5.3,4.5-10.5,7.7-15.4,9.6c-5,1.9-10.2,2.8-15.9,2.8c-9.3,0-16.5-2.3-21.5-6.8c-5-4.6-7.5-10.4-7.5-17.5c0-4.2,0.9-8,2.8-11.4c1.9-3.4,4.4-6.2,7.5-8.3c3.1-2.1,6.5-3.7,10.4-4.7c2.8-0.7,7.1-1.5,12.8-2.2c11.6-1.4,20.2-3.1,25.7-5c0-2,0.1-3.2,0.1-3.8c0-5.9-1.3-10-4.1-12.4c-3.7-3.3-9.2-4.9-16.4-4.9c-6.8,0-11.8,1.2-15,3.6c-3.2,2.4-5.6,6.6-7.2,12.6l-14.1-1.9c1.3-6,3.4-10.9,6.3-14.6c2.9-3.7,7.2-6.6,12.7-8.6c5.6-2,12-3,19.3-3c7.3,0,13.2,0.8,17.7,2.6c4.5,1.7,7.9,3.9,10,6.5c2.1,2.6,3.6,5.9,4.5,9.8c0.5,2.5,0.7,6.9,0.7,13.3v19.2c0,13.4,0.3,21.9,0.9,25.4c0.6,3.6,1.8,7,3.6,10.2H73.2C71.8,148.3,70.8,144.8,70.4,140.8z M69.2,108.6c-5.2,2.1-13.1,3.9-23.6,5.5c-5.9,0.8-10.1,1.8-12.6,2.9c-2.5,1.1-4.4,2.6-5.7,4.7c-1.3,2-2,4.3-2,6.8c0,3.9,1.5,7.1,4.4,9.6c2.9,2.6,7.2,3.9,12.8,3.9c5.6,0,10.5-1.2,14.8-3.6c4.3-2.4,7.5-5.8,9.5-10c1.6-3.3,2.3-8.1,2.3-14.4V108.6z"
          />
          <path
            fill={colour}
            d="M164.1,99.2c0.4-0.2,0.8-0.4,1.2-0.7c2.4-2,5.1-3.7,7.7-5.5c1.2-1.3,2.5-2.6,3.8-3.9c-1.7-5-3.9-9.3-6.7-12.9c-3-3.8-6.9-6.8-11.5-8.9c-4.6-2.1-9.6-3.2-14.9-3.2c-9.4,0-17.2,3.8-23.3,11.4V33.9H106v110.9c3.4-3.3,7.3-6.3,11.3-8.9c2-1.9,3.8-3.9,6-5.6c-2.8-4.6-4.2-11.9-4.2-22.1c0-10.4,2.3-18.3,6.9-23.7c4.6-5.5,10-8.2,16.4-8.2c6.3,0,11.6,2.6,16,7.9C161.4,87.7,163.2,92.9,164.1,99.2z"
          />
          <path
            fill={colour}
            d="M246,105L109.3,215.6L78,176.9L214.7,66.3L246,105L246,105z"
          />
          <path fill={colour} d="M61.3,222.1l9.2-39.3l31.3,38.7L61.3,222.1z" />
        </g>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 896 896"
      >
        <path
          fill={colour}
          d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
        />
      </svg>
    </div>
  )
}

SearchHighlightedText.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.any
}
